import type { MetaTagsProps } from 'svelte-meta-tags';
import {
  SITE_KEYWORDS,
  SITE_NAME,
  SITE_PAGES,
  SOCIAL_IMAGE_ALT,
  SOCIAL_IMAGE_HEIGHT,
  SOCIAL_IMAGE_PATH,
  SOCIAL_IMAGE_WIDTH,
  absoluteUrl
} from '$lib/utils/site';

export const prerender = true;

export async function load({ url }) {
  return {
    baseMetaTags: getBaseMetaTags(url),
    url: url.pathname
  };
}

function getBaseMetaTags(url: URL) {
  const canonicalUrl = absoluteUrl(url.pathname);
  const openGraphImageUrl = absoluteUrl(SOCIAL_IMAGE_PATH);
  const { title, description } = SITE_PAGES.home;

  const metatags = Object.freeze({
    title,
    description,
    canonical: canonicalUrl,
    keywords: SITE_KEYWORDS,
    additionalRobotsProps: { maxImagePreview: 'large' as const, maxSnippet: -1, maxVideoPreview: -1 },
    additionalMetaTags: [
      { name: 'author', content: SITE_NAME },
      { name: 'application-name', content: SITE_NAME },
      { name: 'apple-mobile-web-app-title', content: SITE_NAME },
      { name: 'format-detection', content: 'telephone=no' }
    ],
    languageAlternates: [
      { hrefLang: 'en-IN', href: canonicalUrl },
      { hrefLang: 'x-default', href: canonicalUrl }
    ],
    additionalLinkTags: [{ rel: 'sitemap', type: 'application/xml', href: '/sitemap.xml' }],
    openGraph: {
      type: 'website',
      url: canonicalUrl,
      locale: 'en_IN',
      title,
      description,
      siteName: SITE_NAME,
      images: [
        {
          url: openGraphImageUrl,
          alt: SOCIAL_IMAGE_ALT,
          width: SOCIAL_IMAGE_WIDTH,
          height: SOCIAL_IMAGE_HEIGHT,
          secureUrl: openGraphImageUrl,
          type: 'image/jpeg'
        }
      ]
    },
    twitter: {
      cardType: 'summary_large_image' as const,
      title,
      description,
      image: openGraphImageUrl,
      imageAlt: SOCIAL_IMAGE_ALT
    }
  }) satisfies MetaTagsProps;

  return metatags;
}
